export class CFDIPartidaModel{
    public idCFDIDetalle: string;
    public idActividad: number;
    public idTipoCriterio: number;
    public idTipoContenido: number;
    public idTipoMaterial: number;
    public idSE: number;
    public numeroDePartida: number;
    public numeroSubPartida: number;
    public cantidad: number;
    public noIdentificacion: string;
    public partida: string;
    public valorUnitario: number;
    public valorFacturado: number;
    public claveUnidadSAT: any;
    public claveProductoSAT: any;
    public fraccionArancelaria: any;
    public porcentajeCN: number;
    public justificacion: string;
    public actividadConcepto: string;
    public codigoSE: string;
    public actividad: string;
    public grupo: string;
    public nombreGrupo: string;
    public tipoContenido: string;
    public fechaRegistro: any;
    public proveedor: string;
    public costoDeCompra: number;
    public pcnBienes: number;
    public pcnMateriales: number;
    public pcnServicios: number;


    constructor(){}
}

